<template>
    <div class="col-md-3 col-6">
        <div class="shop_item shop_item-trainer"
             @click="this.$router.push({
                name: 'ShopTrainer',
                params: {
                    categoryId: this.categoryId,
                    trainerId: item.id
                },
                query: {
                    categoryName: this.categoryName
                }
             })"
        >
            <div class="shop_item-trainer_profile">
                <div class="shop_item-trainer_image">
                    <img :src="item.photo" onerror="this.parentElement.style.display='none'">
                </div>
                <div class="shop_item-trainer_rating" v-if="item.rating !== null">
                    <i>
                        <img src="../../assets/img/star.svg" alt="">
                    </i>
                    {{item.rating}}
                </div>
            </div>
            <div class="shop_item-trainer_data">
                <div class="shop_item-trainer_name">
                    {{item.name}}
                </div>
                <div class="shop_item-trainer_position">
                    {{position}}
                </div>
                <div class="shop_item-trainer_price">
                    от <currency-symbol :price="this.item.price"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CurrencySymbol from "../CurrencySymbol";
    export default {
        name: "ShopTrainerItem",
        components: {CurrencySymbol},
        props: {
            item: {},
            categoryId: Number,
            categoryName: String,
        },
        computed: {
            position() {
                let string = this.item.function
                let maxLength = 50
                return string !== undefined ? (string.length > maxLength ? string.slice(0, maxLength) + "..." : string) : ''
            },
        }
    }
</script>